'use strict';

wbApp.factory('previewInterestSvc', ['$resource', '$translate', 'notificationSvc', 'repositorySvc',
    function ($resource, $translate, notificationSvc, repositorySvc) {

        var PreviewInterest = $resource('/Api/PreviewInterests/Get', {}, {
            'query': { method: 'GET', isArray: true },
            'book': { method: 'POST', url: '/Api/PreviewInterests/Book' },
        });

        var previewInterests;
        var forSemesterID;

        function getAll(semesterID) {
            if (!previewInterests || forSemesterID != semesterID) {
                previewInterests = repositorySvc.get(PreviewInterest, { semesterID: semesterID });
                forSemesterID = semesterID;
            }
            return previewInterests;
        }

        function bookLesson(data, successCallback, errorCallback) {
            PreviewInterest.book({ interestID: data.interestID, courseScheduleID: data.courseScheduleID },
                function (successResult) {
                    if (data.semesterID == forSemesterID) {
                        repositorySvc.entityRemoved(previewInterests, data.interestID);
                    }
                    successCallback(successResult);
                    notificationSvc.notifyInfo(
                        $translate.instant('TXT_ALERT_TITLE_LESSON_BOOKING_SUCCESS'));
                },
                function (errorResult) {
                    if (!!errorCallback) {
                        errorCallback(errorResult.data);
                    } else {
                        notificationSvc.notifyError(
                            $translate.instant('TXT_ALERT_TITLE_LESSON_BOOKING_FAILURE'),
                            notificationSvc.translateError(errorResult.data));
                    }
                })
        };

        return {
            getAll: getAll,
            bookLesson: bookLesson
        }

    }]);